


import React from "react";
import styles from "./styles_total.module.css";

interface TotalData {
  key: number;
  plant: string;
  count: number;
}

const dataSource: TotalData[] = [
  {
    key: 1,
    plant: "Зерно",
    count: 1035023,
  },
  {
    key: 2,
    plant: "Хлопок",
    count: 74694,
  },
  {
    key: 3,
    plant: "Табак",
    count: 1149,
  },
  {
    key: 4,
    plant: "Картофель",
    count: 747591,
  },
  {
    key: 5,
    plant: "Овощи",
    count: 757756,
  },
  {
    key: 6,
    plant: "Культуры",
    count: 190358,
  },
  {
    key: 7,
    plant: "Виноград",
    count: 4523,
  },
   {
    key: 8,
    plant: "Бахчи",
    count: 198757,
  },
];

export const TotalPlantsTable: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <h2>Данные по растеневодству</h2>
        <ul className={styles.table}>
          <li className={styles.header}>
            <span className={styles.cell}>Вид растений</span>
            <span className={styles.cell}>Общее количество тонн</span>
          </li>
          {dataSource.map((item) => (
            <li key={item.key} className={styles.row}>
              <span className={styles.cell}>{item.plant}</span>
              <span className={styles.cell}>{item.count.toLocaleString()}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


